module.exports = __webpack_public_path__ + "static/media/correct-3.bb6c2792.mp3";